/* eslint-disable max-classes-per-file */

class Photo {
  url: string = "";

  constructor(url: string) {
    this.url = url;
  }
}

export class DetailTourRecentlyView {
  tourId: number;

  tourName: string;

  tourSlug: string;

  cityName: string;

  citySlug: string;

  countryName: string;

  countrySlug: string;

  photo: Photo[] = [];

  createDate: string;

  constructor(data: any) {
    this.tourId = data?.tourId || 0;
    this.tourName = data?.tourName || 0;
    this.tourSlug = data?.tourSlug || 0;
    this.cityName = data?.cityName || 0;
    this.citySlug = data?.citySlug || 0;
    this.countryName = data?.countryName || 0;
    this.countrySlug = data?.countrySlug || 0;
    this.photo = (data?.photo || []).map((url: string) => new Photo(url));
    this.createDate = data?.createDate || "";
  }
}

class DataTourRecentlyView {
  tours: DetailTourRecentlyView[];

  count: number;

  constructor(data: any) {
    this.tours = (data?.tours || []).map(
      (value: any) => new DetailTourRecentlyView(value),
    );
    this.count = data?.count || 0;
  }
}

export class ResponseTourRecentlyView {
  status: boolean;

  message: string;

  data: DataTourRecentlyView;

  constructor(data: any) {
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.data = new DataTourRecentlyView(data?.data || {});
  }
}
